import { createFileRoute } from '@tanstack/react-router'
import { MyCooptationsPage } from '@/pages/MyCooptationsPage'

export const Route = createFileRoute('/my-cooptations')({
  component: MyCooptationsPage,
})
